<template lang="pug">
.lesson-block.main-block
  .lesson-block__content.-motion-calculator-table-
    .table
      .table__header
        .table__header-inner
        p.table__title Калькулятор маркетинговой эффективности

    .table__body
      .table__body-content
        //- Nav
        .table__nav
          ul.table__nav-list
            li.table__col.table__col--m
              p.table__col-title РК в FB/Instagram
            li.table__col
              p.table__col-title Итого
            li.table__col(v-for="item in motionCalculator", :key="item.date")
              p.table__col-title {{item.date}}
        //- Content
        .table__content
          .virtual__scroll
            ul.table__row
              li.table__col.table__col--m
                p.table__text Затраты на рекламу, руб
              li.table__col
                p.table__text {{getSum("expenses") | numberFormat}} р
              li.table__col(v-for="(item, idx) in motionCalculator", :key="item.date")
                Input.table__text.table__input(type="numberNew" v-model="item.body.expenses" @input="setData(idx)")

            ul.table__row
              li.table__col.table__col--m
                p.table__text Кол-во показов рекламы, шт
              li.table__col
                p.table__text {{getSum("screenings") | numberFormat}} шт
              li.table__col(v-for="(item, idx) in motionCalculator", :key="item.date")
                Input.table__text.table__input(type="numberNew" v-model="item.body.screenings" @input="setData(idx)")

            ul.table__row
              li.table__col.table__col--m
                p.table__text Кол-во кликов <br /> по рекламе, шт
              li.table__col
                p.table__text {{getSum("click") | numberFormat}} шт
              li.table__col(v-for="(item, idx) in motionCalculator", :key="item.date")
                Input.table__text.table__input(type="numberNew" v-model="item.body.click" @input="setData(idx)")

            ul.table__row
              li.table__col.table__col--m
                p.table__text Кол-во заявок, шт
              li.table__col
                p.table__text {{getSum("applications") | numberFormat}} шт
              li.table__col(v-for="(item, idx) in motionCalculator", :key="item.date")
                Input.table__text.table__input(type="numberNew" v-model="item.body.applications" @input="setData(idx)")

            ul.table__row
              li.table__col.table__col--m
                p.table__text Конверсия <br />Показы - Клики, %
              li.table__col
                p.table__text {{getSum("impressionsConversion") | numberFormat}} %
              li.table__col(v-for="item in motionCalculator", :key="item.date")
                p.table__text {{item.body.impressionsConversion | numberFormat}} {{item.body.impressionsConversion ? '%' : ''}}

            ul.table__row
              li.table__col.table__col--m
                p.table__text Конверсия <br />Клики - Заявки, %
              li.table__col
                p.table__text {{getSum("applicationConversion") | numberFormat}} %
              li.table__col(v-for="item in motionCalculator", :key="item.date")
                p.table__text {{item.body.applicationConversion | numberFormat}} {{item.body.applicationConversion ? '%' : ''}}

            ul.table__row
              li.table__col.table__col--m
                p.table__text Цена Клика/Посетителя <br /> (CPC)
              li.table__col
                p.table__text {{getSum("visitorPrice") | numberFormat}} р
              li.table__col(v-for="item in motionCalculator", :key="item.date")
                p.table__text {{item.body.visitorPrice | numberFormat}} {{item.body.visitorPrice ? 'р' : ''}}

            ul.table__row
              li.table__col.table__col--m
                p.table__text Цена Заявки, руб
              li.table__col
                p.table__text {{getSum("applicationPrice") | numberFormat}} р
              li.table__col(v-for="item in motionCalculator", :key="item.date")
                p.table__text {{item.body.applicationPrice | numberFormat}} {{item.body.applicationPrice ? 'р' : ''}}
</template>

<script>
import mask from './MotionCalculatorMask';

export default {
  data() {
    return {
      motionCalculator: []
    };
  },
  mounted() {
    this.getData();

    if (!this.motionCalculator) {
      localStorage.setItem('motionCalculator', JSON.stringify(mask));
      this.getData();
    }
  },
  methods: {
    getData() {
      this.motionCalculator = JSON.parse(
        localStorage.getItem('motionCalculator')
      );
    },
    setData(idx) {
      if (idx !== undefined) {
        this.setImpressionsConversion(idx);
        this.setApplicationConversion(idx);
        this.setVisitorPrice(idx);
        this.setApplicationPrice(idx);
      }

      localStorage.setItem(
        'motionCalculator',
        JSON.stringify(this.motionCalculator)
      );
    },
    getSum(name) {
      const res = this.motionCalculator.reduce(
        (summ, item) => +summ + +item.body[name],
        0
      );
      return res && res > 0 && isFinite(res) ? res.toFixed(0) : 0;
    },
    setImpressionsConversion(idx) {
      const item = this.motionCalculator[idx].body;
      const res = item.click / item.screenings;

      item.impressionsConversion =
        res && res > 0 && isFinite(res) ? `${(res * 100).toFixed(2)}` : '';
    },
    setApplicationConversion(idx) {
      const item = this.motionCalculator[idx].body;
      const res = item.applications / item.click;

      item.applicationConversion =
        res && res > 0 && isFinite(res) ? `${(res * 100).toFixed(2)}` : '';
    },
    setVisitorPrice(idx) {
      const item = this.motionCalculator[idx].body;
      const res = item.expenses / item.click;

      item.visitorPrice =
        res && res > 0 && isFinite(res) ? `${res.toFixed(2)}` : '';
    },
    setApplicationPrice(idx) {
      const item = this.motionCalculator[idx].body;
      const res = item.expenses / item.applications;

      item.applicationPrice =
        res && res > 0 && isFinite(res) ? `${res.toFixed(2)}` : '';
    }
  }
};
</script>
